webpackJsonp([35783957827783],{

/***/ 94:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(28);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _gatsbyImage = __webpack_require__(27);
	
	var _gatsbyImage2 = _interopRequireDefault(_gatsbyImage);
	
	var _reactIntl = __webpack_require__(10);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var GridItem = function (_Component) {
	  _inherits(GridItem, _Component);
	
	  function GridItem() {
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, GridItem);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.state = {
	      isHover: false
	    }, _this.addHover = function () {
	      _this.setState({ isHover: true });
	    }, _this.removeHover = function () {
	      _this.setState({ isHover: false });
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  GridItem.prototype.render = function render() {
	    var _props = this.props,
	        imageMap = _props.imageMap,
	        link = _props.link,
	        className = _props.className;
	    var isHover = this.state.isHover;
	
	    var title = link;
	
	    if (link === 'progetto') {
	      title = 'Il Progetto';
	    }
	
	    if (link === 'relazioni-e-conferenze') {
	      title = 'Relazioni e conferenze';
	    }
	
	    var locale = 'it';
	
	    if (typeof window !== 'undefined') {
	      locale = window.localStorage.getItem('locale');
	    }
	
	    var linkPrefix = locale === 'it' ? '' : '/en';
	
	    return _react2.default.createElement(
	      _gatsbyLink2.default,
	      {
	        to: linkPrefix + '/' + link,
	        className: 'LinksGrid__Item ' + (className || ''),
	        onMouseEnter: this.addHover,
	        onMouseLeave: this.removeHover,
	        onClick: this.removeHover
	      },
	      _react2.default.createElement(_gatsbyImage2.default, {
	        critical: true,
	        sizes: imageMap[link].node.sizes,
	        style: {
	          position: 'absolute',
	          left: 0,
	          top: 0,
	          width: '100%',
	          height: '100%',
	          zIndex: isHover ? -1 : 0
	        }
	      }),
	      _react2.default.createElement(_gatsbyImage2.default, {
	        fadeIn: false,
	        sizes: imageMap[link + 'Hover'].node.sizes,
	        onLoad: this.stopPreloading,
	        style: {
	          position: 'absolute',
	          left: 0,
	          top: 0,
	          width: '100%',
	          height: '100%',
	          zIndex: isHover ? 0 : -1
	        }
	      }),
	      _react2.default.createElement(
	        'div',
	        { className: 'LinksGrid__Item__Title' },
	        _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'gridItem.' + link })
	      )
	    );
	  };
	
	  return GridItem;
	}(_react.Component);
	
	exports.default = GridItem;
	module.exports = exports['default'];

/***/ }),

/***/ 1093:
/***/ (function(module, exports) {

	// empty (null-loader)

/***/ }),

/***/ 407:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.query = undefined;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(28);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _reactHelmet = __webpack_require__(39);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _gridItem = __webpack_require__(94);
	
	var _gridItem2 = _interopRequireDefault(_gridItem);
	
	__webpack_require__(1093);
	
	var _arrowRight = __webpack_require__(57);
	
	var _arrowRight2 = _interopRequireDefault(_arrowRight);
	
	var _reactIntl = __webpack_require__(10);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var IndexPage = function (_Component) {
	  _inherits(IndexPage, _Component);
	
	  function IndexPage() {
	    _classCallCheck(this, IndexPage);
	
	    return _possibleConstructorReturn(this, _Component.apply(this, arguments));
	  }
	
	  IndexPage.prototype.componentDidMount = function componentDidMount() {
	    if (typeof window !== 'undefined') {
	      window.dispatchEvent(new Event('scroll'));
	    }
	  };
	
	  IndexPage.prototype.render = function render() {
	    var allImages = this.props.data.allImageSharp.edges;
	    var news = this.props.data.datoCmsNewsInHomepage;
	
	    var imageMap = {
	      interviste: allImages.find(function (image) {
	        return image.node.sizes.src.indexOf('interviste_base') >= 0;
	      }),
	      intervisteHover: allImages.find(function (image) {
	        return image.node.sizes.src.indexOf('interviste_hover') >= 0;
	      }),
	      mappe: allImages.find(function (image) {
	        return image.node.sizes.src.indexOf('mappe_base') >= 0;
	      }),
	      mappeHover: allImages.find(function (image) {
	        return image.node.sizes.src.indexOf('mappe_hover') >= 0;
	      }),
	      eventi: allImages.find(function (image) {
	        return image.node.sizes.src.indexOf('eventi_base') >= 0;
	      }),
	      eventiHover: allImages.find(function (image) {
	        return image.node.sizes.src.indexOf('eventi_hover') >= 0;
	      }),
	      'relazioni-e-conferenze': allImages.find(function (image) {
	        return image.node.sizes.src.indexOf('conferenze_base') >= 0;
	      }),
	      'relazioni-e-conferenzeHover': allImages.find(function (image) {
	        return image.node.sizes.src.indexOf('conferenze_hover') >= 0;
	      }),
	      pubblicazioni: allImages.find(function (image) {
	        return image.node.sizes.src.indexOf('pubblicazioni_base') >= 0;
	      }),
	      pubblicazioniHover: allImages.find(function (image) {
	        return image.node.sizes.src.indexOf('pubblicazioni_hover') >= 0;
	      }),
	      progetto: allImages.find(function (image) {
	        return image.node.sizes.src.indexOf('progetto_base') >= 0;
	      }),
	      progettoHover: allImages.find(function (image) {
	        return image.node.sizes.src.indexOf('progetto_hover') >= 0;
	      })
	    };
	
	    var data = this.props.data;
	
	
	    var locale = 'it';
	
	    if (typeof window !== 'undefined') {
	      locale = window.localStorage.getItem('locale');
	    }
	
	    var linkPrefix = locale === 'it' ? '' : '/en';
	
	    return _react2.default.createElement(
	      'div',
	      null,
	      _react2.default.createElement(
	        'div',
	        { className: 'pb-4' },
	        _react2.default.createElement(
	          _reactHelmet2.default,
	          null,
	          _react2.default.createElement(
	            'title',
	            null,
	            data.site.siteMetadata.title
	          )
	        ),
	        news.mostra && _react2.default.createElement(
	          'div',
	          { className: 'Home__News wrap-home' },
	          _react2.default.createElement(_gatsbyLink2.default, {
	            to: '' + linkPrefix + news.paginaCollegata.fields.path,
	            className: 'News',
	            dangerouslySetInnerHTML: { __html: news.testo }
	          }),
	          _react2.default.createElement(
	            _gatsbyLink2.default,
	            { to: '' + linkPrefix + news.paginaCollegata.fields.path },
	            _react2.default.createElement(_arrowRight2.default, { className: 'Home__ArrowIcon' })
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'LinksGrid LinksGrid--2rows wrap-home px-1 mt-2' },
	          _react2.default.createElement(_gridItem2.default, { link: 'progetto', imageMap: imageMap }),
	          _react2.default.createElement(_gridItem2.default, { link: 'mappe', imageMap: imageMap }),
	          _react2.default.createElement(_gridItem2.default, { link: 'eventi', imageMap: imageMap }),
	          _react2.default.createElement(_gridItem2.default, { link: 'interviste', imageMap: imageMap }),
	          _react2.default.createElement(_gridItem2.default, { link: 'relazioni-e-conferenze', imageMap: imageMap }),
	          _react2.default.createElement(_gridItem2.default, { link: 'pubblicazioni', imageMap: imageMap })
	        )
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'Home__Smallprint text-bold' },
	        _react2.default.createElement(
	          'div',
	          { className: 'wrap-narrower' },
	          _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'home.smallprint' })
	        )
	      )
	    );
	  };
	
	  return IndexPage;
	}(_react.Component);
	
	exports.default = IndexPage;
	var query = exports.query = '** extracted graphql fragment **';

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-index-js-f8f6241b5485204cb40e.js